import { NotificationActionType } from '../context/notificationContext/actions';
import { useNotificationContext } from '../context/notificationContext/context';
import { Notification } from '../context/notificationContext/reducer';

type UseNotificationsResponseProps = {
  notification?: Notification;
  setNotification: (notification: Notification) => void;
  clearNotification: () => void;
};

// Hooks act as 'Adapter' layer.
export const useNotification = (): UseNotificationsResponseProps => {
  const { notificationState, notificationDispatch } = useNotificationContext();

  const setNotification = (notification: Notification) => {
    notificationDispatch({
      type: NotificationActionType.SET_NOTIFICATION,
      payload: notification,
    });
  };

  const clearNotification = () => {
    notificationDispatch({
      type: NotificationActionType.SET_NOTIFICATION,
    });
  };

  return {
    notification: notificationState.notification,
    setNotification,
    clearNotification,
  };
};
